import React from 'react'
import { Box, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { FoodItem } from '../../../components'
import NoResultSearch from './NoResultSearch'
import VideoDish from '~/views/Menu/templates/VideoDish'

const ContentSearch = ({ listFood = [], total }) => {
  const { t } = useTranslation()
  if (Array.isArray(listFood) && listFood.length === 0) return <NoResultSearch />

  const dataVideoMenus = listFood.filter((item) => item.is_using_video_menu) // lọc ra những món ăn có video -> hiển thị ở đầu
  const dataNormalMenus = listFood.filter((item) => !item.is_using_video_menu)

  // Hiển thị video menus
  const renderVideoMenus = () => {
    if (dataVideoMenus.length <= 0) return null

    return (
      <Box mb="16px">
        <VideoDish data={dataVideoMenus} />
      </Box>
    )
  }

  const renderNormalMenus = () => {
    return dataNormalMenus.map((foodItem) => <FoodItem key={foodItem.id} {...foodItem} />)
  }

  return (
    <Box marginY="14px">
      <Typography marginBottom="14px" color={'baseColor.colorText1'} paddingX="20px">
        {total} {t('label.items_found')}
      </Typography>
      {renderVideoMenus()}
      {renderNormalMenus()}
    </Box>
  )
}

ContentSearch.propTypes = {
  listFood: PropTypes.array,
  total: PropTypes.number,
}

export default React.memo(ContentSearch)
